module.exports = __webpack_public_path__ + "media/img/super-venue/icons/search-5b9db8f306ee9840b38cb4f427a9342e.svg";